class FormErrorHandler {
	#form;
	
	constructor(form) {
		this.#form = form;
	}
	
	handleErrorResponse(responseObject) {
		const {responseJSON = {}} = responseObject;
		
		this.hideFeedbackMessages();
		
		if (responseJSON.error && responseJSON.error.message) {
			const backendErrorMessageElement = this.#getElement('.backendErrorMessage');
			
			backendErrorMessageElement.innerHTML = responseJSON.error.message;
			backendErrorMessageElement.classList.remove('hidden-element');
		} else if (responseJSON.errors) {
			this.#showBackendErrors(responseJSON.errors);
		} else {
			this.#getElement('.unknownErrorMessage').classList.remove('hidden-element');
		}
		
		this.#getElement('.submitButton').classList.remove('disabled');
	}
	
	hideFeedbackMessages() {
		for (const feedbackEl of this.#form.querySelectorAll('.feedbackMessage')) {
			feedbackEl.classList.add('hidden-element');
		}
	}
	
	#showBackendErrors(errors) {
		for (const [fieldName, errorMessage] of Object.entries(errors)) {
			const errorMessageElement = this.#getElement(`.${fieldName}ErrorMessage`);
			
			if (errorMessageElement) {
				errorMessageElement.classList.remove('hidden-element');
				errorMessageElement.innerHTML = errorMessage;
			}
		}
	}
	
	/**
	 * @param {string} selector
	 * @returns {Element | HTMLInputElement}
	 */
	#getElement(selector) {
		return this.#form.querySelector(selector);
	}
}

export default FormErrorHandler;